
























































































































































































































































































































































































import { Component, Ref, Vue } from 'vue-property-decorator';

@Component
export default class ComponentsDialog extends Vue {
  @Ref('dialog') private rdialog!: HTMLFormElement;

  private SIMPLELIST: object[] = [
    {
      icon: 'person',
      label: 'user1@gmail.com'
    },
    {
      icon: 'person',
      label: 'user2@gmail.com'
    },
    {
      icon: 'add',
      label: 'Add account'
    }
  ];

  private valert0 = false;
  private valert1 = false;
  private valert2 = false;
  private valert3 = false;
  private valert4 = false;
  private valert5 = false;

  private vsimple0 = false;
  private vsimple1 = false;
  private vsimple2 = false;
  private vsimple3 = false;

  private vconfirmation0 = false;
  private vconfirmation1 = false;
  private vradio = 0;
  private vconfirmation2 = false;
  private vconfirmation3 = false;
  private vconfirmation4 = false;

  private vfullScreen0 = false;

  private fbeforeOpen(): void {
    console.log('Dialog will be opened');
  }

  private fbeforeClose(): void {
    console.log('Dialog will be closed');
  }

  private fcancel(): void {
    this.rdialog.fclose();
  }
}
